import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IImport } from '../models/import';


@Injectable({
  providedIn: 'root'
})
export class ImportService {

  constructor(private http: HttpClient) { }

    // Import
    getImports(request: IBaseSearchRequest){
        return this.http.post<IPagedResults<IImport[]>>(
            `${environment.baseUrl}/v1/imports/searchImportsGlobal`,
            request
        )
    }
}
